<template>
  <a-link v-if="link" :to="link">{{ name }}</a-link>
  <span v-else>{{ name }}</span>
</template>

<script>
import { PROP_TYPES, propValidator } from '@/utils/validators'

export default {
  name: 'AAuthor',
  props: {
    name: propValidator([PROP_TYPES.STRING]),
    link: propValidator([PROP_TYPES.STRING, PROP_TYPES.OBJECT], false)
  }
}
</script>
